<!--
  国家P标签
-->
<template>
  <p slot="reference" class="iconP">
    {{ text }}
    <i
      v-show="text != '-'"
      @click="copy(text)"
      class="el-icon-document-copy pointer icon green-Cd0100"
    ></i>
  </p>
</template>

<script>
import AES from "@/mixins/AES";
import { eventBus } from "@/plugins/eventBus";
export default {
  data() {
    return {
      text: "-",
      data: [],
      value: "",
    };
  },
  props: {
    id: {
      default() {
        return "";
      },
    },
    pStyle: {
      default() {
        return "";
      },
    },
  },
  methods: {
    getData(count = 0) {
      if (window.localStorage.getItem("country")) {
        //先查询是否存在国家数据
        this.data = JSON.parse(
          AES.decrypt(window.localStorage.getItem("country"))
        );
        let text = this.data.filter((item) => item.countryId == this.id);
        if (text.length === 0) {
          //没匹配到对应值
          this.text = "-";
        } else {
          this.text =
            this.$i18n.locale === "zh" ? text[0].cnName : text[0].enName;
        }
      } else {
        setTimeout(() => {
          this.getData(count + 1);
        }, 200);
        if (count == 17) {
          this.$api
            .post("/api/AdministrativeDivision/GetCountryBox")
            .then((res) => {
              window.localStorage.setItem(
                "country",
                AES.encrypt(JSON.stringify(res.data))
              );
              this.getData();
            });
        }
      }
    },
  },
  mounted() {
    eventBus.$emit("getCountry");
    eventBus.$off("getCountry");
    this.getData();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.getData();
      },
      immediate: true,
    },
    id(newValue) {
      this.value = newValue;
      this.getData();
    },
  },
};
</script>

<style></style>
